import Vue from "vue";
import VueRouter from "vue-router";
import RouterConfig from './module'
import store from '@/store'
import request from '@/utils/request'
import { wxunshare } from '@/common'
Vue.use(VueRouter);



const routers = new VueRouter({
    scrollBehavior: (to, from, savedPosition) => {
        if ((savedPosition || to.meta.y) && store.getters.hasView.length) {
            const y = savedPosition ? savedPosition : to.meta.y;
            return { y };
        }
        return { x: 0, y: 0 };
    },
    base: process.env.BASE_URL,
    routes: RouterConfig
});
routers.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title || '徐州房地产信息网';
    }
    if (to.path == '/personLottery' || to.path == '/signUpRecord' || to.path == '/myLotterySignUp' || to.path == '/property' || to.path == '/newComplaints') {
        if ((to.query.isApp == 'true' || (to.query.isApp && to.query.isApp != 'false')) || (to.query.isWx == 'true' || to.query.isWx && to.query.isWx != 'false')) {
            to.meta.isLogin = false
        } else {
            to.meta.isLogin = true
        }
    }
    if (to.meta.isLogin) {
        var ua = navigator.userAgent;
        var uaList = ua.split(" ");
        var token = "";
        for (var i = 0; i < uaList.length; i++) {
            if (uaList[i].indexOf("token") > -1) {
                token = uaList[i].split("=")[1];
                break;
            }
        }
        if (token == "") {
            request.post('cms/onlineUser/reg/isLogin.do').then(res => {
                if (res.success) {
                    next();
                    if (to.path != '/oneHouseOnePriceDetail' && to.path != '/announceDetail' && to.path != '/newsDetail' && to.path != '/projectDetail' && to.path != '/preProgress' && to.path != '/buyHouse' && to.path != '/login' && to.path != '/checkHouse' && to.path != '/mechanismDetail' && to.path != '/shopDetail' && to.path != '/agentDetail' && to.path != '/houseDetail') {
                        setTimeout(() => {
                            wxunshare()
                        }, 1000);
                    }
                } else {
                    next('login')
                }
            })
        } else {
            next()
        }
    } else {
        next()
        if (to.path != '/Awelcome' && to.path != '/oneHouseOnePriceDetail' && to.path != '/announceDetail' && to.path != '/newsDetail' && to.path != '/projectDetail' && to.path != '/preProgress' && to.path != '/buyHouse' && to.path != '/login' && to.path != '/checkHouse' && to.path != '/mechanismDetail' && to.path != '/shopDetail' && to.path != '/agentDetail' && to.path != '/houseDetail' && to.path != '/consultingNew' && to.path != '/welcome' && to.path != '/consultingService') {
            setTimeout(() => {
                wxunshare()
            }, 1000);
        }
    }
});
export default routers;